<template>
    <div id="sqWrap" ref="sqWrap">
        <div class="ornotmask" v-show="showjrBox" @click="noHide">
          <div class="maskInner">
            <p class="title">快进入自己的社区吧</p>
            <ul>
            <li>· &nbsp;&nbsp;进入社区后，可以查看同样在本社区内的邻友</li>
            <li>· &nbsp;&nbsp;可以在社区内发布帖子、二手、房产等信息，和邻里互动</li>
            <li>· &nbsp;&nbsp;在签到页面做专属社区任务，赚取更多邻友币</li>
            </ul>
            <!-- 纠错 -->
            <div class="sureBtn" @click.stop="sureInto(0)" v-show="jcType == 0">
                确定进入社区
            </div>
            <div class="sureBtn" @click.stop="sureInto(1)" v-show="jcType == 1">
                确定进入社区
            </div>
            <p class="noInto" @click.stop="noHide">暂不进入</p>
          </div>
        </div>
        <div id="headers">
            <i class="arr" @click="goBack()"></i>
            <p class="title">{{title}}</p>
        </div>
        <div class="setFix"></div>
        <!-- 地图 -->
        <div class="topWrap">
          <div class="mapBox" @click="gowhere">
            <!-- <img :src="mapImg" alt=""> -->
            <img :src="mapImg"  alt="">
            <!-- <span class="weatherIcon">{{weather.weather}} {{weather.temperature}}℃</span> -->
          </div>
          <p class="ptitles clearfix" v-if="streets.length!=0">
            <a href="javascript:;" :class="activeClass ==index ? 'active':''" @click="setInto(index)" :key="index" v-for="(item,index) in streets">{{item.name}}</a>
          </p>
          <div class="gbg"></div>
        </div>
        <div v-if="activeClass==0" >
          <div class="sqlist" :style="{height: sqlistHeight + 'px'}">
            <div v-infinite-scroll="loadMore"
                infinite-scroll-disabled="disabled"
                infinite-scroll-distance="0">
                <div class="item" v-for="(item,i) in sqlists" :key="i">
                    <div class="center">
                        <span class="tag">{{item.typeName}}</span>
                    </div>
                    <div class="left">
                        <div class="top clearfix">
                            <p class="name">{{item.department}}</p>
                            <p class="phone" @click="call(item.contact)">{{item.contact}}</p>
                        </div>
                        <p class="address" @click="intoappMap(item.lng,item.lat,item.address)">{{item.mapAddress}}{{item.address}}</p>
                    </div>
                    <div class="right" @click="intoError(0),jcDetail({type:0,typeId:item._id,name:item.department,phone:item.contact,lng:item.lng,lat:item.lat,poiid:poiid,address:item.address,mapAddress:item.mapAddress,typeName:item.typeName})">
                        纠错
                    </div>
                </div>
                <div class="isfoot " v-show="isFoot" style="border-bottom:0;margin-bottom:30px;"> 我已经到底了...</div>
                <div class="item" ref="bottom" v-show="showSwitch==false || sqlists.length!=0" style="height: 50px;border-bottom:0;"></div>
            </div>
            <div class="noLists" v-show="showSwitch==true && sqlists.length==0">
                <!-- <p>这里空空如也~</p> -->
                <p class="so">快来补充第一条社区信息吧~</p>
                <div class='bcBtn'>
                    <span class="lname">物业：</span>待补充<br/>
                    <span class="lname">居委会：</span>待补充<br/>
                    <span class="lname">其他：</span>待补充
                </div>
            </div>
          </div>
          <div class="btmBox">
            <mt-button type="danger" class="submitBtn" @click.stop="intoError(1)">补充信息</mt-button>
          </div>
        </div>
        <div v-else>
          <Jdlist/>
        </div>
    </div>
</template>

<script>
import Top from '@/component/top/top'
import axios from 'axios'
import {Toast, Indicator} from 'mint-ui'
import Jdlist from '../jdlist/jdlist'
export default {
    data() {
        return {
            isFoot:false,
            title:'社区信息',
            jcType:2,
            pageNum:1,
            disabled:false,
            sqlists:[],
            showSwitch:false,
            jcMsg:{},
            token:'',
            showjrBox:false,
            poiid:this.getcurrentuserCommunity().poiId,
            moveTime:this.getMovetime(),
            openid:this.$route.query.openid,
            userpoiId:this.getuserCommunity().poiId,
            sqlistHeight: document.documentElement.offsetHeight - 44,
            streets:[
              {name: "社区",type: "communityInfos"},
              {name: "街道",type: "streetInfos"}
            ],
            activeClass: 0,
        }
    },
    components:{
        Top,
        Jdlist
    },
    created() {
        if (this.isAndroid() || this.isIos()) {
            if(this.isAndroid()) {
                window.app.postToken('postToken')
                window["getToken"] = token => {
                    this.setuserToken(token)
                    this.getUserInfo()
                }
            }else if(this.isIos()) {
                window.webkit.messageHandlers.postToken.postMessage('')
                window.getToken = this.getToken
            }
        }else{
            this.getUserInfo()
        }
    },
    computed:{
      mapImg() {
        let currentObj = this.getcurrentuserCommunity();
        let location = `${currentObj.lng},${currentObj.lat}`
        return `https://restapi.amap.com/v3/staticmap?location=${location}&zoom=16&size=750*300&markers=mid,,A:${location}&key=${localStorage.getItem(
          "key"
        )}`;
      }
    },
    methods:{
      gowhere() {
        this.isScreen(
          `app://map?lng=${localStorage.getItem(
            "lon"
          )}&lat=${localStorage.getItem("lat")}`
        );
      },
        goBack() {
            this.$router.push({path:`/?poiId=${this.$route.query.id}`}) 
        },
        // 拨打电话
        call(tel) {
            this.isScreen(`app://tel?mobile=${tel}`)
        },
        postToken() {

        },
        getToken(token) {
            this.setuserToken(token)
            // 调取方法
            this.getUserInfo()
        },
        getUserInfo() {
            axios.post(this.commonIp()+'/v1/mobile/community/userInfo',{token:this.getuserToken()})
            .then((res) => {
                if(res.data.code == '200') {
                    if(res.data.data.community) {
                        this.userpoiId = res.data.data.community.poiId
                        this.setuserCommunity(res.data.data.community)
                    }
                    this.setuserToken(res.data.data.token)
                    this.setMovetime(res.data.data.moveTime)
                }
            }).catch((error) => {
                // Toast('请求失败')
            })
        },
        intoError(type) {
            // 点击纠错判断登录未登录及入驻未入驻
            if (this.getuserToken() == "") {
                // 触屏版 app 跳转
                if (this.isAndroid() || this.isIos()) {
                    window.location.href = "app://login";
                } else {
                    let url = `${this.commonIp()}/htmls/community/#/?poiId=${this.poiid}`;
                    window.location.href = `${this.commonIp()}/quickLogin?referer=${encodeURIComponent(window.location.href)}`;
                }
            } else {
                if (this.userpoiId === this.poiid) {
                //用户当前选择得社区和用户本身所属得社区是一样得
                    if (this.getMovetime() != "0") {
                        if(type==1) {
                            this.$router.push({path:'/errcon',query:{title:'补充信息',id:this.$route.query.id}})
                        }else{
                            this.$router.push({path:'/errcon',query:{title:'纠错',id:this.$route.query.id}})
                        }
                    } else {
                        // 未加入
                        this.showjrBox = true;
                        // 弹出加入弹层
                        if(type==1) {
                            this.jcType = 1
                        }else{
                            this.jcType = 0
                        }
                    }
                } else {
                    //当前用户选择得社区和用户本身得社区不一样
                    this.showjrBox = true;
                    // 弹出加入弹层
                    if(type==1) {
                        this.jcType = 1
                    }else{
                        this.jcType = 0
                    }
                }
            }
        },
        // 进入客户端地图
        intoappMap(lng,lat,address) {
            this.isScreen(`app://map?lng=${lng}&lat=${lat}&address=${address}`)
        },
        // 隐藏遮罩
        noHide() {
          this.showjrBox = false
        },
        // 确定进入小区
        sureInto(type) {
            axios.post(this.commonIp()+"/v1/mobile/community/edit", {
                poiId: this.poiid,
                join: "1",
                token: this.getuserToken()
            }).then(res => {
                if (res.data.code == "200") {
                    Toast({
                        message: "进入成功",
                        iconClass: "icon icon-success"
                    });
                    this.userpoiId = this.poiid;
                    if (type == 0) {
                        // 进入纠错
                        this.setMovetime(new Date().getTime());
                        this.showjrBox = false
                        this.$router.push({path:'/errcon',query:{title:'纠错',id:this.$route.query.id}})
                    } else {
                        this.showjrBox = false
                        this.$router.push({path:'/errcon',query:{title:'补充信息',id:this.$route.query.id}})
                    }
                }
            });
        },
        getwyLists(obj) {
          let _this = this
            this.disabled = true
            Indicator.open()
            axios.get( `${this.commonIp()}/v1/communityInfo/index?poiId=${obj.id}&page=${this.pageNum}`)
            .then((res) =>{
                Indicator.close()
                if(res.data.code==200) {
                  if (res.data.data.infos && res.data.data.infos.length != 0) {
                    _this.sqlists = _this.sqlists.concat(res.data.data.infos);
                    ++_this.pageNum;     
                    _this.disabled = false;
                    _this.showSwitch = false
                  }else{
                    if(res.data.data.infos.length == 0 && _this.pageNum == 1){
                        _this.isFoot = false;
                        _this.showSwitch = true
                    }else{
                        _this.isFoot = true;
                        _this.showSwitch = false
                    }
                  }
                } else {
                    Toast(res.data.message);
                }
            })
            .catch(error => {
                Indicator.close()
                if (obj.pageNum == 1) return
                this.$refs.sqWrap.scrollTop = this.$refs.sqWrap.scrollTop - this.$refs.bottom.offsetHeight
                this.disabled = false
            })
        },
        jcDetail(obj) {
            if(obj){
                this.jcMsg = obj
                localStorage.setItem('jcMsg',JSON.stringify(obj))
            }
        },
        loadMore() {
          this.getwyLists({id:this.$route.query.id})
        },
        setInto(index) {
          this.activeClass = index;
        },
    }
    
}
</script>

<style lang="less">
@import '~@/assets/less/index.less';
    #sqWrap{
        height: 100vh;
        .topWrap{
          background: #fff;
          position: fixed;
          top:44px;
          z-index:999;
          width: 100%;
          .gbg{
            height: 10px;
            background: #f2f2f2;
          }
        }
        .ornotmask .maskInner{
            height: auto;
        }
        .mapBox {
          overflow: hidden;
          padding:5px 15px;
          position: relative;
          border-bottom: 1px solid #f2f2f2;
          img{
            border-radius: 10px;
            width: 100%;
            height: 100px;
            object-fit: cover;
          }
        }
        .ptitles {
          height: 42px;
          padding: 0 33px;
          line-height: 42px;
          margin: 0 0 16px 0;
          a {
            font-weight: 700;
            .fl();
            display: inline-block;
            text-align: center;
            color: @gray;
            font-size: @ft15;
            width: 50%;
            position: relative;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            &.active {
              color: @fc32;
              &::after {
                position: absolute;
                bottom: 0;
                left: 50%;
                content: "";
                width: 50px;
                height: 2px;
                margin-left: -25px;
                background: #3d8bfc;
              }
            }
          }
      }
        .sqlist{
            overflow-y: scroll;
            padding-top:182px;
            // padding-bottom: 60px;
            .item{ 
                display:flex;
                border-bottom:1px solid #d8d8d8;
                padding:15px 0 12px 15px;
                &:first-child{
                    border-top:1px solid #d8d8d8;
                }
                .center{
                    margin:0 10px 0 0;
                    .tag{
                        font-size:@ft12;
                        padding:0 5px;
                        border:1px solid #979797;
                        border-radius:5px;
                        max-width:60px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        height: 21px;
                        line-height: 21px;
                        display: inline-block;
                    }
                }
                .left{
                    flex:1;
                    max-width: 70%;
                    padding:0 10px 0 0;
                    .top{
                        margin:0 0 2px 0;
                        line-height: 21px;
                        width:100%;
                        p{
                            font-size:@ft16;
                            vertical-align: middle;
                            &.name{
                                color:@fc32;
                                overflow: hidden;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                max-width: 164px;
                            }
                            &.phone{
                                max-width:164px;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                overflow: hidden;
                                color:#238dd4;
                                margin:2px 0 5px 0;
                            }
                        }
                    }
                    .address{
                        font-size:@ft12;
                        text-overflow: -o-ellipsis-lastline;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        line-clamp: 2;
                        -webkit-box-orient: vertical;
                        background:url('~@/assets/imgs/dw22.png') no-repeat left 2px;
                        background-size:11px;
                        padding-left:16px;
                        vertical-align: middle;
                    }
                }
                .right{
                    flex:0 0 14%;
                    text-align: center;
                    width:14%;
                    font-size:@ft12;
                    border-left:1px solid #d8d8d8;
                    height: 40px;
                    line-height: 40px;
                    margin:14px 0 0 0;
                    color:@gray;
                }
            }
        }
    }
</style>




// WEBPACK FOOTER //
// src/pages/sqmsg/sqmsg.vue